import React, { useEffect, useState } from 'react';
import { Gift, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToCollections = () => {
    document.getElementById('collections')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <div className="hero-image-wrapper">
          <img 
            src="https://images.unsplash.com/photo-1765167029837-cd5dd16896b9?w=1920&q=80" 
            alt="Beautiful gift wrapping" 
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
      </div>
      
      <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
        <h1 className="hero-title">
          You Pick It, We Make It
          <br />
          <span className="hero-title-emphasis">Pinterest Perfect ✨</span>
        </h1>
        
        <p className="hero-subtitle">
          Send us your product, choose a style, and we’ll make beautiful packaging for it.
          Because your gifts deserve to be special 💝
        </p>
        
        <div className="hero-buttons">
          <Button 
            onClick={scrollToCollections}
            className="hero-button primary"
            size="lg"
          >
            <Gift className="w-5 h-5 mr-2" />
            Create Your Gift
          </Button>
          
          <Button 
            onClick={scrollToCollections}
            variant="outline"
            className="hero-button secondary"
            size="lg"
          >
            Explore Themes
          </Button>
        </div>
      </div>

      <div className="hero-scroll-indicator">
        <div className="scroll-line"></div>
        <span className="scroll-text">Scroll to explore</span>
      </div>
    </section>
  );
};

export default Hero;
